import { SVGIcon } from '@superops/super-icons';
import {
  Avatar,
  Badge,
  DisplayText,
  SkeletonBodyText,
  TextStyle,
  Tippy
} from '@superops/ui-design-system';
import { isEmpty } from 'lodash';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { getTranslatedText } from '@nile/components';
import TimerComponent from './subpages/ChatBubble/TimerComponent';

export const getIntials = (name) => {
  const nameSplit = name.split(' ');
  if (nameSplit.length > 1) {
    return `${nameSplit[0][0]}${nameSplit[1][0]}`;
  }
  return `${nameSplit[0][0] || null}`;
};

function ChatTitle({
  profile,
  actions,
  collapse,
  roundedBorder,
  chatStatus,
  setChatStatus,
  closeSession,
  messageCount,
  loading,
  isChooseTemplate,
  isWeb,
  onHeaderClick = () => {}
}) {
  const intl = useIntl();
  const showEarlyAccess =
    isWeb && !isChooseTemplate && !loading && !collapse?.state;

  return (
    <div
      className={`chatTitle full-width ${
        isChooseTemplate ? '' : 'navBlackBackground'
      }  p20 ${showEarlyAccess ? 'pt-25' : ''} z99 ${
        roundedBorder ? 'brTop10' : ''
      }`}
      aria-hidden="true"
      onClick={onHeaderClick}
    >
      {showEarlyAccess && (
        <div className="position-absolute top-0">
          <Badge status="warning" size="small" capitalize>
            <DisplayText>
              <FormattedMessage id="common.label.early.access" />
            </DisplayText>
          </Badge>
        </div>
      )}
      <div
        className={`flex actr ${
          collapse?.state ? 'height10' : 'height40'
        } max-height-40`}
      >
        {isChooseTemplate && isWeb && !loading ? (
          <div className="flex fx22 full-width g20">
            <DisplayText weight="bold" size="extraLarge">
              {getTranslatedText(intl, 'msp.chat.chooseTemplate')}
            </DisplayText>
          </div>
        ) : (
          <div className="flex fx22 full-width g20">
            {profile?.icon ? (
              <div className="flex actr">
                <SVGIcon name={profile?.icon} size="xl" />
              </div>
            ) : (
              <>
                {!isEmpty(profile?.name) ? (
                  <div className="flex actr">
                    <Avatar initials={getIntials(profile?.name)} size="small" />
                  </div>
                ) : (
                  <></>
                )}
              </>
            )}
            <div
              className={`flex fcol jctr ${
                collapse?.state && messageCount ? 'f11' : ''
              }`}
            >
              <div className="flex actr white-color g10">
                <DisplayText weight="SemiBold" size="large">
                  {profile?.name}
                </DisplayText>
                {window.networkDisconnect && (
                  <Tippy
                    title="Network connectivity issue, check after sometime"
                    position="bottom"
                  >
                    <div className="flex actr">
                      <SVGIcon name="Revert" color="red" size="sm" />
                    </div>
                  </Tippy>
                )}
              </div>
              {!collapse?.state && (
                <>
                  {loading ? (
                    <div className="mt10">
                      <TextStyle variation="subdued">
                        <SkeletonBodyText lines={1} />
                      </TextStyle>
                    </div>
                  ) : (
                    <>{profile?.description && <>{profile?.description}</>}</>
                  )}
                </>
              )}
            </div>

            {collapse?.state && messageCount > 0 && (
              <div className="flex-center mlr10 full-height">
                <Badge status="critical" size="small" radial>
                  <TextStyle weight="SemiBold">{messageCount}</TextStyle>
                </Badge>
              </div>
            )}
          </div>
        )}

        {collapse?.state && chatStatus?.sessionInitiated && !loading && (
          <div className="flex mlr10 full-width jend text-white actr">
            <TimerComponent
              onlyTimer
              chatStatus={chatStatus}
              setChatStatus={setChatStatus}
              closeSession={closeSession}
              minimise={collapse?.state}
            />
          </div>
        )}
        {!isEmpty(actions) && (
          <div className="fx jend nonDraggable">
            {collapse?.state ? (
              <></>
            ) : (
              <div className="fx g10 ptr">
                {actions?.map((el, ind) => {
                  return el?.hasOwnProperty('component') ? (
                    <>{el?.component}</>
                  ) : (
                    <div key={`ind-${ind}`} onClick={el?.onClick} aria-hidden>
                      <SVGIcon color={el?.iconColor} name={el?.iconName} />
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default ChatTitle;
